import { jsonMember, jsonObject } from 'typedjson';
import { Nillable } from '@web/utils';

@jsonObject
export class MultimediaUpdateRequest {
  @jsonMember(String) public readonly title!: string;
  @jsonMember(String) public readonly alternativeText?: Nillable<string>;
  @jsonMember(String) public readonly description?: Nillable<string>;

  public constructor(
    title: string,
    alternativeText?: Nillable<string>,
    description?: Nillable<string>,
  ) {
    this.title = title;
    this.alternativeText = alternativeText;
    this.description = description;
  }
}
